module.exports = __webpack_public_path__ + "static/media/info-solid-full.c226d564.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/info-solid-full.svg
// module id = 265
// module chunks = 0